import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import styles from './Card.style';

const Card = ({
  leftBorder,
  disableDepth,
  children,
  className: classNameProp,
  tabIndex,
  isTab,
  isSmallScreen,
  ...other
}) => {
  const className = clsx(styles.root, classNameProp, {
    [styles.leftBorderPurple]: leftBorder && !isTab,
    [styles.leftBorderYellow]: leftBorder && isTab,
    [styles.unselectedTab]: !leftBorder && isTab,
    [styles.disableDepth]: disableDepth,
  });

  return (
    <div className={className} data-testid={leftBorder ? 'cardWithBorder' : 'card'} {...other}>
      {children}
    </div>
  );
};

Card.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  leftBorder: PropTypes.bool,
  disableDepth: PropTypes.bool,
  isTab: PropTypes.bool,
  tabIndex: PropTypes.number,
  isSmallScreen: PropTypes.bool,
};

Card.defaultProps = {
  className: '',
  leftBorder: false,
  disableDepth: false,
  isTab: false,
  isSmallScreen: false,
  tabIndex: 0,
};

export default Card;
